// TODO [monorepo refactor]: Move this into a shared npm package.
export enum CompanyFundingStage {
  AngelRound = 'ANGEL_ROUND',
  GrandRound = 'GRANT_ROUND',
  PreSeedRound = 'PRE_SEED_ROUND',
  SeedRound = 'SEED_ROUND',
  SeriesA = 'SERIES_A',
  SeriesB = 'SERIES_B',
  SeriesC = 'SERIES_C',
  SeriesD = 'SERIES_D',
  SeriesE = 'SERIES_E',
  SeriesF = 'SERIES_F',
  SeriesG = 'SERIES_G',
  SeriesH = 'SERIES_H',
  SeriesI = 'SERIES_I',
  SeriesJ = 'SERIES_J',
  SeriesK = 'SERIES_K',
  PostIpoEquityRound = 'POST_IPO_EQUITY_ROUND',
  VentureRound = 'VENTURE_ROUND',
  PrivateEquityRound = 'PRIVATE_EQUITY_ROUND',
  DebtFinancing = 'DEBT_FINANCING',
  PostIpoDebt = 'POST_IPO_DEBT',
  Other = 'OTHER',
}
